import { useApiClientDocument } from '~/@api/client/useApiClientDocument'
import type { IRevenueFeeInvoiceOkResponse } from '~/@api/generated-api-types-document/Api'
import { downloadPDF } from '~/@lib/utils/files.utils'

// Faktúra k mesačnému poplatku z výnosu — presunuté z Meteor
// `user/account/portfolio/transactions/revenue-fee-tax-document` na Nest
// `POST /document/revenue-fee-invoice` (`/document` doc, apiClientDocument).
function useTransactionDownloads() {
  const client = useApiClientDocument()

  async function fetchRevenueFeeTaxDocumentPdf(
    transactionId: string,
    callback: (resp: IRevenueFeeInvoiceOkResponse) => void
  ) {
    client.document
      .pdfGeneratorsControllerGetRevenueFeeInvoice(
        { transactionId },
        {
          secure: true,
        }
      )
      .then((resp) => {
        callback(resp.data)
      })
      .catch((err) => {
        console.error(err)
      })
  }

  function downloadRevenueFeeTaxDocumentPdf(transactionId: string) {
    fetchRevenueFeeTaxDocumentPdf(transactionId, (resp) => {
      downloadPDF(resp.data, `faktura-${resp.invoiceCode}.pdf`)
    })
  }

  return {
    downloadRevenueFeeTaxDocumentPdf,
  }
}

export { useTransactionDownloads }
